export default {
  show(value) {
    const Intercom = window['Intercom'];
    if (Intercom) {
      Intercom(value);
    } else {
      window.open('mailto:support@cidirectinvesting.com', '');
    }
  },
  execute(value, properties?) {
    const Intercom = window['Intercom'];
    if (Intercom) {
      Intercom(value, properties);
    }
  }
};
